import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { combineLatest, filter, Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { USER_ROLES } from '../enums/UserRoles.enum';
import { IUser } from '../interfaces/IUser';
import { UserState } from '../states/user.state';

@Injectable({
  providedIn: 'root',
})
export class ServiceLanePoolAccessGuard {
  private router = inject(Router);
  private store = inject(Store);
  private user$: Observable<IUser> = this.store.select<IUser>(UserState.user);
  private isUserLoading$: Observable<boolean> = this.store.select<boolean>(UserState.isLoading);

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([this.user$, this.isUserLoading$]).pipe(
      filter(([user, isLoading]: [IUser, boolean]) => !isLoading && !!user.employeeId),
      take(1),
      map(([user]: [IUser, boolean]) =>
        user.role === USER_ROLES.TECHNISCHER_CONTROLLER || user.isMemberOfServiceLanePool ? true : this.router.createUrlTree(['/home']),
      ),
    );
  }
}
